import React, { memo } from 'react';
import classNames from 'classnames/bind';
import styles from './label.module.scss';
var cn = classNames.bind(styles);
var BLOCK_NAME = 'Label';
export var labelColors = {
    grey: 'grey',
    richGrey: 'richGrey',
    white: 'white',
};
export var Label = memo(function (_a) {
    var _b;
    var children = _a.children, disabled = _a.disabled, htmlFor = _a.htmlFor, required = _a.required, _c = _a.colorType, colorType = _c === void 0 ? 'richGrey' : _c, isNotHover = _a.isNotHover;
    return (React.createElement("label", { className: cn(BLOCK_NAME, (_b = {},
            _b["".concat(BLOCK_NAME, "--").concat(labelColors[colorType])] = Boolean(colorType),
            _b["".concat(BLOCK_NAME, "--required")] = required,
            _b["".concat(BLOCK_NAME, "--disabled")] = disabled,
            _b["".concat(BLOCK_NAME, "--no-hover")] = isNotHover,
            _b)), "data-name": "Label", htmlFor: htmlFor }, children));
});
